module.exports = __webpack_public_path__ + "61c65de7953f08d74cd3099d953a11e0.jpg";